export default "__VITE_ASSET__DIN9iyDl__"